import styled from 'styled-components';
import { clearfix, media } from 'styles/Mixins';
import * as Homie from 'styles/Home/StyledHome';

export const Wrapper = styled(Homie.Wrapper)`
  ${clearfix}
  background-color: #FFFFFF;
  padding-top: 60px;
`;

export const LeftSide = styled.div`
  width: 100%;
  height: 100%;
  ${media.md`
    float: left;
    width: 50%;
    height: 100%;
  `}
`;

export const RightSide = styled.div`
  display: none;
  ${media.md`
    display: block;
    float: right; 
    width: 50%;
    height: 100%;
  `}
`;

export const RowBody = styled.div`
  height: calc(100vh - 60px);
  ${media.md`
    display: table-cell;
    vertical-align: middle;
    width: 512px;
    height: calc( 100vh - 15vh);
  `}
`;

export const ImageRight = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${({ coverImg }) => coverImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: calc(85vh - 0px);
`;

export const Container = styled.div`
  margin: 0 auto;
  height: 100%;
  width: ${({ width }) => width};
`;

export const Label = styled.label.attrs({
  style: ({ fsize, mBottom }) => ({
    fontSize: fsize,
    marginBottom: mBottom
  })
})`
  color: #4a4a4a;
  line-height: 24px;
  font-weight: ${({ fWeight }) => (fWeight ? fWeight : 500)};
`;

export const Button = styled.button`
  width: 300px;
  height: 35px;
  line-height: 19px;
  color: #ffffff;
  border: none;
  border-radius: 2px;
  font-size: 16px;
  font-weight: bold;
  background-color: #278c7e;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
`;
